module.exports = __webpack_public_path__ + "static/media/Revit LT.4e5a42bf.png";